/* eslint-disable no-undef */
/**
 * Funciones utilitarias puras para el dominio de citas médicas.
 */

/**
 * Retorna el nombre de la especialidad actualmente seleccionada.
 * Prioriza el placeholder de nombre si existe.
 * @param {object} state - Estado del componente orquestador.
 * @returns {string}
 */
export const getSpecialityName = (state) => {
  if (state.namePlaceholderSpec) return state.namePlaceholderSpec;
  if (!state.especialidades?.length || !state.specialitySelected) return '';
  const selected = state.especialidades.find(
    (item) => item.ServiceCode === state.specialitySelected,
  );
  return selected?.ServiceName || '';
};

/**
 * Obtiene las sedes seleccionadas por el usuario, desde la selección global o localStorage.
 * @returns {string}
 */
export const getFilteredSelectedLocations = () => {
  const auxsede = localStorage.getItem('SedesCodeAux');
  if (compensar?.selectedAppointmentPlaces?.length > 0) {
    const selectedLocations = compensar.selectedAppointmentPlaces.map((x) => x.itemText);
    return selectedLocations.length > 1 ? selectedLocations.join('|') : selectedLocations.join('');
  }
  return auxsede;
};

/**
 * Construye el objeto de petición para buscar disponibilidad de citas médicas.
 * @param {object} state - Estado del componente orquestador.
 * @returns {object}
 */
export const setDataToAppointmentByUser = (state) => {
  let getQueryType = '';

  if (state.statusRequest === 1) {
    const doctorId = String(state.medicalAvailable.AssignedDoctor.DoctorId || '');
    const doctorTypeId = String(state.medicalAvailable.AssignedDoctor.UserTypeId || '');
    const isPersonalDoctor = !!state.personalDoctor;
    const useDoctorTypeId = isPersonalDoctor && doctorTypeId.length > 0;

    // En V1 (isRedService=false), medico personal puede venir como DoctorId = TID + NID.
    // En V2, DoctorId normalmente llega como NID (sin prefijo de tipo).
    const isV1Flow = state.isRedService === false;
    const personalDoctorId = useDoctorTypeId && isV1Flow && doctorId.startsWith(doctorTypeId)
      ? doctorId.slice(doctorTypeId.length)
      : doctorId;

    getQueryType = {
      Type: state.statusRequest,
      Doctor: {
        // TIDMedico solo aplica para medico personal; tratante conserva parseo historico por DoctorId.
        TypeId: useDoctorTypeId ? doctorTypeId : doctorId.slice(0, 1),
        Id: useDoctorTypeId ? personalDoctorId : doctorId.slice(1),
      },
    };
  } else if (state.statusRequest === 2) {
    if (state.oneBranche) {
      getQueryType = {
        Type: state.statusRequest,
        Branches: [state.oneBrancheSelected?.Code ? state.oneBrancheSelected.Code : null],
      };
    } else {
      getQueryType = {
        Type: state.statusRequest,
        Branches: state.branchSelectedResponse.map((branch) =>
          branch.itemId === undefined ? branch : branch.itemId,
        ),
      };
    }
  } else {
    getQueryType = { Type: state.statusRequest };
  }

  return {
    UserTypeId: state.userTypeId,
    UserId: state.afiliateSelected,
    ServiceCode: state.specialitySelected?.length ? state.specialitySelected : state.serviceCode,
    Program: state.dataToSubmitAppoimentGroup,
    RequestDate: state.dateSelected,
    QueryType: getQueryType,
  };
};

/**
 * Construye el objeto de datos de la persona para persistir en localStorage.
 * @param {object} state - Estado del componente orquestador.
 * @returns {object}
 */
export const setDataToPerson = (state) => ({
  program: state.userTypeIdentify,
  name: state.namePlaceholderUser,
  nameService: state.namePlaceholderSpec,
  itemSedes: state.itemSedes,
  innerPerson: state.medicalAvailable,
  BirthDate: state.BirthDate,
  PBSLocation: compensar.PBSLocation,
});

/**
 * Verifica si un valor está definido (no null ni undefined).
 * @param {*} data
 * @returns {boolean}
 */
export const isDefined = (data) => data !== null && data !== undefined;

/**
 * Evalúa si el médico asignado tiene nombre completo definido en la respuesta del servicio.
 * Función pura que reemplaza la lógica de checkInit / checkInitTrue mezclada con setState.
 * @param {object} data - Respuesta del servicio o del resultado del médico.
 * @param {boolean} isRedService - Si está usando el flujo ConsultaRedV2.
 * @returns {boolean}
 */
export const hasDoctorAssigned = (data, isRedService) => {
  if (isRedService) {
    if (data?.AssignedDoctor !== undefined) {
      return !!(data.AssignedDoctor?.FullName?.length > 0);
    } else if (data?.Result?.AssignedDoctor !== undefined) {
      return !!(data.Result.AssignedDoctor?.FullName?.length > 0);
    }
  }
  if (data?.Result) {
    return !!data.Result.AssignedDoctor;
  }
  return false;
};
